export default __webpack_public_path__ + "static/media/848.7f447d0b.png";